import Hero from './Hero'

const AboutView = () => {
	return (
		<div>
			<Hero text='About' />
			<div className='container'>
				<div className='row'>
					<div className='col-lg-8 offset-lg-2 my-5'>
						<p className='lead'>
							Welcome to my movie app! You can search for movies
							or select from the new movies on the main page. This
							app pulls movie data from the TMDB API, including
							movie trailers! Have a look around there are all
							kind of movies to explore!
						</p>
					</div>
				</div>
			</div>
		</div>
	)
}

export default AboutView
